module.exports = __webpack_public_path__ + "img/bat.fc6a5468.svg";